const url = (value: string): string | undefined =>
  value && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/.test(value)
    ? 'Must be a valid URL.'
    : undefined;

export default url;
